export const ChadGPTTool = () => {
  return (
    <div>ChadGPT</div>
  )
}